import {
  SHChip,
  SHImage,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import { ProductRecommendationDTO } from "@models/platform-analysis/entities/steps/summary";
import { memo } from "react";

interface ProductRecommendationsLogoProps {
  recommendationData: Partial<ProductRecommendationDTO>;
  isReview?: boolean;
  disabled?: boolean;
}

export const ProductRecommendationsLogo = memo(
  ({
    recommendationData,
    isReview,
    disabled,
  }: ProductRecommendationsLogoProps) => {
    const { productLogo, productName, isProductMain } = recommendationData;

    return (
      <SHStack
        width={"100%"}
        height={"100%"}
        direction={"row"}
        justifyContent={"space-between"}
        position={"relative"}
      >
        <SHStack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={1.5}
          flex={1}
          paddingRight={2}
        >
          <SHStack
            direction={"row"}
            gap={1.5}
            alignItems={"center"}
            justifyContent={"center"}
            paddingY={0.5}
          >
            <SHImage src={productLogo} width={35} height={35} />

            <SHTypography
              disabled={disabled}
              variant="subtitle1"
              fontWeight={600}
              fontSize={13}
              lineHeight={1.2}
            >
              {productName}
            </SHTypography>
          </SHStack>

          {isProductMain && (
            <SHChip
              size="small"
              className="ProductCell-main-badge sub-product"
              label={isReview ? "Current" : "Main"}
              color={"warning"}
              variant={"outlined"}
              sx={{
                top: -5,
                fontSize: "10px",
                fontWeight: 500,
                padding: "2px",
                "&>.MuiChip-label": {
                  padding: "0px 4px",
                  textOverflow: "initial",
                },
                height: "auto",
                maxWidth: "none",
              }}
            />
          )}
        </SHStack>
      </SHStack>
    );
  },
);
